import { render, staticRenderFns } from "./shiftManagementAssistant.vue?vue&type=template&id=ee05ce80&scoped=true"
import script from "./shiftManagementAssistant.vue?vue&type=script&lang=js"
export * from "./shiftManagementAssistant.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementAssistant.vue?vue&type=style&index=0&id=ee05ce80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee05ce80",
  null
  
)

export default component.exports